import { apiRequest } from '../../services/apiClient';

export function startContractExtraction(formData) {
  return apiRequest('/contracts/extract', {
    method: 'POST',
    body: formData,
  });
}

export function listExtractionJobs() {
  return apiRequest('/contracts/extract/jobs');
}

export function dismissExtractionJob(jobId) {
  return apiRequest(`/contracts/extract/${jobId}`, {
    method: 'DELETE',
  });
}
